/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cra_Modal_WarningInputs */

const en_cra_modal_warning = /** @type {(inputs: Cra_Modal_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a new date was agreed, cancel and use CAD instead.`)
};

const ja_cra_modal_warning = /** @type {(inputs: Cra_Modal_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい日付を合意した場合は、キャンセルしてCADを使用してください。`)
};

const fr_cra_modal_warning = /** @type {(inputs: Cra_Modal_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si une nouvelle date a été convenue, annulez et utilisez plutôt CAD.`)
};

const de_cra_modal_warning = /** @type {(inputs: Cra_Modal_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn ein neuer Termin vereinbart wurde, abbrechen und stattdessen CAD verwenden.`)
};

/**
* | output |
* | --- |
* | "If a new date was agreed, cancel and use CAD instead." |
*
* @param {Cra_Modal_WarningInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cra_modal_warning = /** @type {((inputs?: Cra_Modal_WarningInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cra_Modal_WarningInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cra_modal_warning(inputs)
	if (locale === "ja") return ja_cra_modal_warning(inputs)
	if (locale === "fr") return fr_cra_modal_warning(inputs)
	return de_cra_modal_warning(inputs)
});